import * as React from "react"
import { MessageSkeleton } from "../../common/skeletons"
import { Flex } from "@chakra-ui/react"

interface FadeChatProps {
  isSmallView?: boolean
  fadingDirections?: "bottom" | "top"
}

export const FadeChat: React.FC<FadeChatProps> = ({
  isSmallView,
  fadingDirections
}): JSX.Element => {
  return (
    <Flex
      flexDirection={fadingDirections === "top" ? "column-reverse" : "column"}
    >
      <MessageSkeleton
        containerProps={{ opacity: "35%", width: "100%" }}
        offFade={true}
        isSmallView={isSmallView}
      />
      <MessageSkeleton
        isSmallView={isSmallView}
        offFade={true}
        containerProps={{ opacity: "25%", width: "65%" }}
      />
      <MessageSkeleton
        isSmallView={isSmallView}
        offFade={true}
        containerProps={{ opacity: "15%", width: "80%" }}
      />
      <MessageSkeleton
        isSmallView={isSmallView}
        offFade={true}
        containerProps={{ opacity: "5%", width: "50%" }}
      />
    </Flex>
  )
}
